import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { ProductoAgricolaService } from '../../_services/producto-agricola.service';
import { ProductoAgricola } from '../../_models/producto-agricola';
import { PlagaProductoAgricola } from '../../_models/plaga-producto-agricola';
import { Plaga } from '../../_models/plaga';
import { PlagaProductoAgricolaService } from '../../_services/plaga-producto-agricola.service';

@Component( {
  selector: 'app-plaga-producto',
  templateUrl: 'plaga-producto.component.html'
} )

export class PlagaProductoComponent implements OnInit {
  formulario: FormGroup;
  @Input() plaga: Plaga;
  plagaProducto: PlagaProductoAgricola;

  /** Listas */
  lisPlagaProducto: PlagaProductoAgricola[] = [];
  lisProductoAgricolaTodos: ProductoAgricola[] = [];
  lisProductoAgricola: SelectItem[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  rowGroupMetadata: any;
  tabSeleccionado = 'VARIABLE';
  submitted = false;
  guardando = false;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serPlagaProductoAgricola: PlagaProductoAgricolaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private serProductoAgricola: ProductoAgricolaService
  ) {
  }

  ngOnInit() {

    if ( this.plaga && (this.plaga.idPlaga !== '' && this.plaga.idPlaga !== null && this.plaga.idPlaga !== undefined) ) {
      /** Se carga la plaga producto comercial */
      this.serPlagaProductoAgricola.listadoPorPlaga( this.plaga.idPlaga ).subscribe( registros => {
        this.lisPlagaProducto = registros;
        this.cargarInformacionInicial();
      } );
    }

  }

  cargarInformacionInicial() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/plaga' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PLAGA.LBL_PRODAGRICOLA' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idPlaga: [ this.plaga ? this.plaga.idPlaga : null, [ Validators.required ] ],
      idPlagaProductoAgricola: [ this.plagaProducto ? this.plagaProducto.idPlagaProductoAgricola : null ],
      idProductoAgricola: [ this.plagaProducto ? this.plagaProducto.idProductoAgricola : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.plagaProducto ? this.plagaProducto.indicadorHabilitado : true, [ Validators.required ] ]
    } );

    this.serProductoAgricola.listadoHabilitados().subscribe( registros => {
      this.lisProductoAgricolaTodos = registros;
      this.lisProductoAgricolaTodos.map( ( s: ProductoAgricola ) => {
        if ( !this.lisPlagaProducto.find( x => x.idProductoAgricola === s.idProductoAgricola ) )
          this.lisProductoAgricola.push( { label: s.nombre, value: s.idProductoAgricola } );
      } );

      this.carTabla = false;
      this.carInformacionInicial = false;
    } );


  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      /** Actualizar plaga producto comercial */
      if ( formulario.idPlagaProductoAgricola ) {
        this.serPlagaProductoAgricola.actualizar( formulario ).subscribe( regActualizado => {
          this.lisPlagaProducto = [];
          this.serPlagaProductoAgricola.listadoPorPlaga( this.plaga.idPlaga ).subscribe( registros => {
            this.lisPlagaProducto = registros;
            this.guardando = false;
            this.submitted = false;
            this.carTabla = false;
            this.plagaProducto = null;
            this.formulario.reset();
            this.f.idPlaga.setValue( this.plaga.idPlaga );
            this.f.indicadorHabilitado.setValue( true );
            this.verificarLista();
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGACTU' )
            } );
          } );
        } );

      } else {
        /** Crear plaga producto comercial */
        this.serPlagaProductoAgricola.crear( formulario ).subscribe( reg => {
          this.lisPlagaProducto = [];
          this.serPlagaProductoAgricola.listadoPorPlaga( this.plaga.idPlaga ).subscribe( regActualizado => {
            this.lisPlagaProducto = regActualizado;
            this.guardando = false;
            this.submitted = false;
            this.carTabla = false;
            this.plagaProducto = null;
            this.formulario.reset();
            this.f.idPlaga.setValue( this.plaga.idPlaga );
            this.f.indicadorHabilitado.setValue( true );
            this.verificarLista();
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGGUAR' )
            } );
          } );
        } );
      }


    }
  }

  editar( reg: PlagaProductoAgricola ) {
    let prodAgri = this.lisProductoAgricolaTodos.find( x => x.idProductoAgricola === reg.idProductoAgricola );
    this.lisProductoAgricola.push( { label: prodAgri.nombre, value: prodAgri.idProductoAgricola } );
    this.plagaProducto = reg;
    this.formulario.reset();
    this.f.idPlaga.setValue( this.plaga.idPlaga );
    this.f.idPlagaProductoAgricola.setValue( this.plagaProducto.idPlagaProductoAgricola );
    this.f.idProductoAgricola.setValue( this.plagaProducto.idProductoAgricola );
    this.f.indicadorHabilitado.setValue( this.plagaProducto.indicadorHabilitado );
  }

  verificarLista() {
    this.lisProductoAgricola = [];
    this.lisProductoAgricolaTodos.map( ( s: ProductoAgricola ) => {
      if ( !this.lisPlagaProducto.find( x => x.idProductoAgricola === s.idProductoAgricola ) )
        this.lisProductoAgricola.push( { label: s.nombre, value: s.idProductoAgricola } );
    } );
  }

}
